import PropTypes from 'prop-types';
import React, { Component } from 'react';
import PromoBar from 'launch/components/PromoBar';
import { FormattedMessage } from 'react-intl';
import connectToStores from 'fluxible-addons-react/connectToStores';
import { clearStatus } from 'launch/actions/designBriefActions';
import DraftStore, { STATUS_ERROR, STATUS_SUCCESS } from 'launch/stores/DraftStore';
import Icon from 'launch/components/Icon';
import { trackEvent } from '@99designs/utils/platform';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

export class BriefStatus extends Component {
    constructor(props) {
        super(props);
        this.handleDismiss = this.handleDismiss.bind(this);
    }

    handleDismiss() {
        this.context.executeAction(clearStatus);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.status !== this.props.status;
    }

    renderError() {
        trackEvent('Viewed Visual Brief Error', {
            error: this.props.error
        });

        return (
            <PromoBar
                variations={['launch', 'error']}
                dismissible={true}
                onDismiss={this.handleDismiss}>
                <Icon icon="exclamation-point-2" offsetRight={true} />
                <FormattedMessage id='status.error' />
            </PromoBar>
        );
    }

    renderSuccess() {
        return (
            <PromoBar
                variations={['launch', 'active']}
                dismissible={true}
                onDismiss={this.handleDismiss}>
                <Icon icon="info-1" offsetRight={true} />
                <FormattedMessage id='status.success' />
            </PromoBar>
        );
    }

    renderStatus() {
        switch (this.props.status) {
            case STATUS_SUCCESS:
                return this.renderSuccess();
            case STATUS_ERROR:
                return this.renderError();
        }
    }

    render() {
        return (
            <ReactCSSTransitionGroup transitionName="slide-down" transitionEnter={true} transitionEnterTimeout={333} transitionLeaveTimeout={0}>
                {this.props.status && this.renderStatus()}
            </ReactCSSTransitionGroup>
        )
    }
}

BriefStatus.contextTypes = {
    executeAction: PropTypes.func.isRequired,
    getStore: PropTypes.func.isRequired,
}

BriefStatus.propTypes = {
    status: PropTypes.oneOf([
        STATUS_SUCCESS,
        STATUS_ERROR
    ])
};

export default connectToStores(BriefStatus, [DraftStore], (context, prop) => {
    return {
        status: context.getStore(DraftStore).notifyStatus
    };
});



// WEBPACK FOOTER //
// ./js/launch/components/BriefStatus.jsx